import EDPDescription from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPDescription/EDPDescription';

export default EDPDescription;
